import { render } from "./RequestCreate.vue?vue&type=template&id=7324ead7"
import script from "./RequestCreate.vue?vue&type=script&lang=js"
export * from "./RequestCreate.vue?vue&type=script&lang=js"

import "./RequestCreate.vue?vue&type=style&index=0&id=7324ead7&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__